
import {ReactElement, ReactNode} from 'react'
import {withStyles, WithStyles} from '@material-ui/core/styles'
import compose from 'lodash/flowRight'
import {withNamespaces, Trans} from 'react-i18next'
import {economicProfileQuestions} from '@bdswiss/common-enums'
import Typography from '@material-ui/core/Typography'

import messages from '../../../../../assets/messages'
import {styles} from './styles'
import {FieldsSection} from '../FieldsSection'

type UserProfileAndInvestmentObjectivesProps = {
  renderQuestion: (question) => ReactNode,
  isShowDocumentsUploadSection: boolean,
} & WithStyles

function UserProfileAndInvestmentObjectivesBase(props: UserProfileAndInvestmentObjectivesProps): ReactElement {
  const {
    classes,
    renderQuestion,
    isShowDocumentsUploadSection
  } = props

  return (
    <FieldsSection title={<Trans {...messages.userProfileAndInvestmentObjectives} />}>
      <div className={classes.row}>
        {renderQuestion(economicProfileQuestions.nomineeStatus)}
        {renderQuestion(economicProfileQuestions.commercialRationaleForBusinessRelationship)}
      </div>
      {isShowDocumentsUploadSection ? (
        <div className={classes.documentFields}>
          <Typography variant="body1">
            <Trans {...messages.pleaseUploadTheRequiredDocuments} />
          </Typography>
          {renderQuestion(economicProfileQuestions.identityOfTheThirdParty)}
          {renderQuestion(economicProfileQuestions.proofsOfIdentityFiamlRegulations)}
          {renderQuestion(economicProfileQuestions.relationshipThirdParty)}
        </div>
      ) : null}
      <div className={classes.row}>
        {renderQuestion(economicProfileQuestions.riskToleranceForCfd)}
      </div>
    </FieldsSection>
  )
}

const UserProfileAndInvestmentObjectives = compose(withStyles(styles), withNamespaces())(UserProfileAndInvestmentObjectivesBase)
export {UserProfileAndInvestmentObjectives}
